export default {
    path : "factory-carrier-recycled",
    name : "factory-carrier-recycled",
    meta : {
        title : "载体回收站"
    },
    component: () => import('@/pages/factory/recycledCarrier/Index'),
    redirect: {
        name : "factory-carrier-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-carrier-recycled-whole',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-carrier-recycled-recent',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-carrier-recycled-atme',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-carrier-recycled-meat',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-carrier-recycled-reply',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-carrier-recycled-search',
            meta: {
                title: '厂房载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/recycledcarrier/inedx.js